import { WebsitePricingIntervalsDTO } from './website-pricing-intervals.dto';

export class WebsitePricingDTO {

   sek: WebsitePricingIntervalsDTO;

   eur: WebsitePricingIntervalsDTO;

}
